import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { RegisterFormCompanyComponent } from '../../../main/register/register-form-company/register-form-company.component';
import { GetUserCompany } from 'src/app/models/company/get-company';
import { GetAddress } from 'src/app/models/security/register-request';
import { CompanyService } from 'src/app/services/company.service';
import { AlertService } from 'src/app/services/alert.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-company-details-admin',
  standalone: true,
  imports: [CommonModule, RegisterFormCompanyComponent],
  templateUrl: './company-details-admin.component.html',
  styleUrls: ['./company-details-admin.component.css']
})
export class CompanyDetailsAdminComponent implements OnInit {
  
  isLoading: boolean = false;
  isFound: boolean = false;
  companyId: number = 0;
  company: GetUserCompany | null = null;
  addresses: GetAddress[] = [];

  userId: number = 0;

  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private companyService = inject(CompanyService);
  private alertService = inject(AlertService);
  private userService = inject(UserService);

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.companyId = +params['id'];
        this.getCompanyData();
      } else {
        this.router.navigate(['/admin/companies']);
      }
    });
  }

  getCompanyData(): void {
    this.isLoading = true;
    
    this.companyService.getCompany(this.companyId).subscribe({
      next: (res) => {
        if (res && res.length > 0) {
          this.company = res[0];
          this.isFound = true;
          this.userId = this.company.userId;
          this.getAddresses();
          this.isLoading = false;
        }
      },
      error: (err) => {
        if (err) {
          this.alertService.showErrorAlert(err[0]);
        } else {
          this.alertService.showErrorAlert('Error al consultar la información de la empresa');
        }
        this.router.navigate(['/admin/companies']);
      }
    }).add(() => {
      this.isLoading = false;
    });
  }

  getAddresses(): void {
    this.isLoading = true;
    
    this.userService.getAddresses(this.userId).subscribe({
      next: (res) => {
        this.addresses = res;
      },
      error: (err) => {
        if (err) {
          this.alertService.showErrorAlert(err[0]);
        } else {
          this.alertService.showErrorAlert('Error al consultar las direcciones de la empresa');
        }
      }
    }).add(() => {
      this.isLoading = false;
    });
  }

  goBack(): void {
    this.router.navigate(['/admin/companies']);
  }
}
